var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkIconLtr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06729 23.411C5.48481 17.6474 5.39198 12.097 5.56186 6.2509C5.59487 5.10919 4.698 4.15999 3.55973 4.1256C2.42077 4.09122 1.47023 4.99224 1.43653 6.13395C1.27559 11.6775 1.40559 16.9527 0.060298 22.4274C-0.212063 23.5347 0.465415 24.6558 1.57136 24.924C2.67663 25.1992 3.79562 24.5183 4.06729 23.411Z",
    fill: "#12141D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1101 34.5815C25.7267 25.7916 34.7875 14.4846 41.1206 3.06745C41.6729 2.07017 41.3131 0.811478 40.3172 0.261253C39.3213 -0.288971 38.0641 0.0687065 37.5118 1.06599C31.3878 12.1048 22.6248 23.0406 13.326 31.5346C12.4856 32.305 12.4271 33.6117 13.1954 34.4508C13.9636 35.2899 15.2697 35.3518 16.1101 34.5815Z",
    fill: "#12141D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5458 44.1816C27.3411 45.6328 36.4067 43.1568 44.4042 39.656C45.4476 39.1952 45.9235 37.9779 45.4675 36.9393C45.0108 35.8939 43.7928 35.4193 42.7494 35.8732C35.4658 39.0645 27.2283 41.4305 19.2177 40.11C18.0939 39.9243 17.0313 40.6877 16.8463 41.8088C16.6606 42.9298 17.4226 43.9959 18.5458 44.1816Z",
    fill: "#12141D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkIconLtr);
export default __webpack_public_path__ + "static/media/sparkIconLtr.37305b7db4d8016f55f6a8fbda8eb451.svg";
export { ForwardRef as ReactComponent };